export default __webpack_public_path__ + "static/media/bunny.775003f3.png";